// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFound_wrapper__UGSJa","code":"NotFound_code__xnz+t","title":"NotFound_title__oQg0L","desc":"NotFound_desc__rdswO","backBtn":"NotFound_backBtn__ICpyX"};